var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepColor1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.895,
    height: 79.634,
    viewBox: "0 0 78.895 79.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34352",
    "data-name": "Group 34352",
    transform: "translate(1.75 1.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29788",
    "data-name": "Group 29788"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    y1: 51.515,
    transform: "translate(18.455 20.143)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    y2: 51.515,
    transform: "translate(56.94 20.143)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    y2: 39.407,
    transform: "translate(72.868 32.252)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    y2: 39.008,
    transform: "translate(2.527 32.651)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: 17.512,
    transform: "translate(57.883 26.054)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x2: 17.512,
    transform: "translate(0 26.054)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x2: 73.378,
    transform: "translate(1.009 76.134)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x2: 23.462,
    transform: "translate(25.967 28.53)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x2: 23.462,
    transform: "translate(25.967 38.024)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x2: 23.462,
    transform: "translate(25.967 47.518)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x2: 23.462,
    transform: "translate(25.967 57.011)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x2: 23.462,
    transform: "translate(25.967 66.505)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 4.232,
    transform: "translate(62.82 38.024)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x2: 4.232,
    transform: "translate(62.82 47.518)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 4.232,
    transform: "translate(62.82 57.011)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x2: 4.232,
    transform: "translate(62.82 66.505)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x1: 4.232,
    transform: "translate(8.076 38.024)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x1: 4.232,
    transform: "translate(8.076 47.518)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x1: 4.232,
    transform: "translate(8.076 57.011)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x1: 4.232,
    transform: "translate(8.076 66.505)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_471",
    "data-name": "Ellipse 471",
    cx: 10.845,
    cy: 10.845,
    r: 10.845,
    transform: "translate(27.095)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x1: 6.599,
    transform: "translate(53.639 15.668)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x2: 6.599,
    transform: "translate(15.643 15.668)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29787",
    "data-name": "Group 29787",
    transform: "translate(32.892 5.797)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    y1: 10.097,
    transform: "translate(5.049)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x1: 10.097,
    transform: "translate(0 5.049)",
    fill: "none",
    stroke: "#3ec6cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepColor1);
export default __webpack_public_path__ + "static/media/stepColor1.32b24cb93cde920474165a03981802b2.svg";
export { ForwardRef as ReactComponent };